import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal , ButtonToolbar} from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            tax_type: "",
            tax_community: "",
            inventoryOwner: null,
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            failed_errors: [],
            taxType: [],
            availableOwners: [],
            taxCommunity: [],
            username_val: '',
            password:'',
            errors: {}, // State for error messages
            sgst_tax_rate : 0,
            cgst_tax_rate : 0
        };
    }

    Failedtoggle= () =>{
      this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew= () =>{
      this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    toggleBack=()=>{
        window.location.href="/upload/item_master?tab=tax_master";  
    }

   handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "sgst_tax_rate" || name === "cgst_tax_rate") {
        const taxValue = value ? parseFloat(value) : 0;
        this.setState(prevState => ({
            [name]: taxValue,
            errors: { ...prevState.errors, [name]: '' }
        }));
    } else {
        this.setState(prevState => ({
            [name]: value,
            errors: { ...prevState.errors, [name]: '' }
        }));
    }
};


    componentDidMount(){
        this.getTaxTypeCommunity();
    }

  

    handleRoleChange = (selectedOption) => {
      this.setState({
          role: selectedOption,
          role_val: selectedOption ? selectedOption.value : '', // Handle case when option is cleared
          errors: { ...this.state.errors, role: '' }
      });
    };

    handleCityChange = (selectedOption) => {
      this.setState({
          city: selectedOption,
          city_val: selectedOption ? selectedOption.value : '', // Handle case when option is cleared
          errors: { ...this.state.errors, city: '' }
      });
    };

    getTaxTypeCommunity = () => {
        
      API.get('/tax/v1/tax-type-community/')
      .then((response) => response.data)
      .then((data) => {
        console.log('tax data',data)
        const arr_tax_type = data.data.tax_type.map(item => ({
          value: item.id,
          label: item.tax_type
        }));
        const arr_tax_community = data.data.tax_community.map(item => ({
          value: item.id,
          label: item.name
        }));
          this.setState({ taxType: arr_tax_type, taxCommunity: arr_tax_community });
      })
      .catch((error) => console.error(error));
       
    };

    handleCityInputChange = (inputValue) => {
        
      
       
    };

    handleWarehouseInputChange = (inputValue) => {
        if (inputValue) {
            API.get(`/location/warehouse-autocomplete/?search=${inputValue}`)
                .then((response) => response.data)
                .then((data) => {
                    const arr = data.map(item => ({
                        value: item.code,
                        label: item.name
                    }));
                    this.setState({ availableWarehouses: arr });
                })
                .catch((error) => console.error(error));
        }
    };

    handleInvenInputChange = (inputValue) => {
      if (inputValue) {
          API.get(`/customer/inv-autocomplete/?search=${inputValue}`)
              .then((response) => response.data)
              .then((data) => {
                  const arr = data.map(item => ({
                      value: item.code,
                      label: item.name
                  }));
                  this.setState({ availableOwners: arr });
              })
              .catch((error) => console.error(error));
      }
    };

    

    handleOwnerChange = (selectedOption) => {
      this.setState({
          inventoryOwner: selectedOption,
          inventoryOwner_val: selectedOption ? selectedOption.value : '',
          errors: { ...this.state.errors, inventoryOwner: '' }
      });
    };

    handleWarehouseChange = (selectedOptions) => {
        this.setState({ warehouses: selectedOptions });
        const selectedWarehouses = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ warehouses_val: selectedWarehouses });
    };


    createGroup = () => {
        console.log(this.state.tax_community)

        this.setState({
            loading: true
        })
        const errors = {};

        if (!this.state.taxgroup) errors.taxgroup = "Tax Group is required";
        if (!this.state.tax_group_description) errors.tax_group_description = "Description is required";
        if (!this.state.tax_type) errors.tax_type = "Tax Type is required";
        if (!this.state.tax_community) errors.tax_community = "Tax Community is required";
        if (!this.state.cgst_tax_rate) errors.cgst_tax_rate = "CGST Rate is required";
        if (!this.state.sgst_tax_rate) errors.sgst_tax_rate = "SGST Rate is required";
        if (!this.state.igst_tax_rate) errors.igst_tax_rate = "IGST Rate is required";

        if (Object.keys(errors).length > 0) {
          this.setState({
            failed_message: "Please fill all required fields.",
            failed_errors: Object.entries(errors),
            failedModal: true,
            loading: false
          });
          return;
        }
        const payload = {
            tax_group : {
                "group": this.state.taxgroup,
                "description": this.state.tax_group_description

            },
            "tax_type": this.state.tax_type,
            "tax_basis": 0,
            "tax_community": this.state.tax_community,
            "cgst_tax_rate": this.state.cgst_tax_rate,
            "igst_tax_rate": this.state.igst_tax_rate,
            "sgst_tax_rate": this.state.sgst_tax_rate,
        };

        API.post('/tax/v1/group_v2/', { param: payload })
            /*.then((response) => response.data)
            .then((data) => {*/
            .then((response) => {
                const { data, status } = response; // 👈 keep both data and status
                console.log("Status code:", status);
                console.log("Response data:", data);

                if(status == "201" ){
                    this.setState({
                        success_message: response.data.message,
                        modalNew: true,
                        loading: false
                    }); 
                    return false;
                }

                if(response.data.status == "success"){
                    this.setState({
                        success_message: response.data.message,
                        modalNew: true,
                        loading: false
                    }); 
                }else{
                    
                    this.setState({
                        failed_message: response.data.message,
                        failedModal: true,
                        loading: false
                    });
                }

                /*this.setState({
                    success_message: data[0].message,
                    username_val: data[0].username,
                    password: data[0].password,
                    modalNew: true,
                });*/

            })
           .catch((error) => {
              console.log(error.response)
               console.log(error.response.status)
                if (error.response.status == "400") {
                    const errors = error.response.data.data ? Object.entries(error.response.data.data) : [];
                    this.setState({
                        failed_message: error.response.data.message,
                        failed_errors: errors,
                        failedModal: true,
                        loading: false
                    });
                } else {
                    console.log(error);
                }
            });
    }

    render() {
        const { errors, modalNew, failedModal } = this.state;

        return (
            <div className="createuser_container" style={{ width: '100%', margin: '1%' }}>

                <div style={{
                    background: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    marginBottom: '120px'
                }}>
                <Form>
                    <span style={{marginBottom: '12%', fontSize: 15, fontWeight: 'bold', color: 'black'}}> Tax Details </span>
                    <Row form style={{marginTop: '2%'}}>
                        <Col md={4}>

                            <FormGroup>
                                <Label for="username">Tax Group</Label>
                                <Input
                                    type="text"
                                    name="taxgroup"
                                    id="mobile"
                                    value={this.state.taxgroup}
                                    onChange={this.handleChange}
                                    required
                                />
                                
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="city">Tax Community</Label>
                               {/* <Select
                                    name="taxCommunity"
                                    value={this.state.taxCommunity}
                                    onChange={this.handleCityChange}
                                    onInputChange={this.handleCityInputChange}
                                    options={this.state.taxCommunity}
                                    placeholder="Select Tax Community"
                                    isClearable
                                />*/}
                                <select
                                    id="brandSelect"
                                    name="tax_community"
                                    className="form-control"
                                    value={this.state.tax_community}
                                    style={{ fontSize: 13, }}
                                    onChange={this.handleChange}
                                    required 
                                >
                                <option value="">Select Community</option>
                                {
                                  this.state.taxCommunity.length > 0 &&
                                  this.state.taxCommunity.map((brandData) => {
                                    return (
                                      <option value={brandData.value}> {brandData.label}</option>
                                    );
                                  })}
                                </select>

                               
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="city">Tax Type</Label>
                               {/* <Select
                                    name="taxType"
                                    value={this.state.taxType}
                                    onChange={this.handleCityChange}
                                    onInputChange={this.handleCityInputChange}
                                    options={this.state.taxType}
                                    placeholder="Select Tax Type"
                                    isClearable
                                />*/}
                                <select
                                    id="brandSelect"
                                    name="tax_type"
                                    className="form-control"
                                    value={this.state.tax_type}
                                    style={{ fontSize: 13, }}
                                    onChange={this.handleChange}
                                    required
                                >
                                <option value="">Select Type</option>
                                {
                                  this.state.taxType.length > 0 &&
                                  this.state.taxType.map((brandData) => {
                                    return (
                                      <option value={brandData.value}> {brandData.label}</option>
                                    );
                                  })}
                                </select>
                                
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={8}>
                            <FormGroup>
                                <Label for="email">Tax Group Description</Label>
                                <Input
                                    type="text"
                                    name="tax_group_description"
                                    maxLength={100}
                                    id="email"
                                    onChange={this.handleChange}
                                    required
                                   
                                />
                               
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="mobile">CGST Tax Rate</Label>
                                <Input
                                    type="text"
                                    name="cgst_tax_rate"
                                    id="mobile"
                                    onChange={this.handleChange}
                                    required
                                    
                                />
                               
                            </FormGroup>
                        </Col>
                       
                    </Row>
                    <Row form>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="mobile">SGST Tax Rate</Label>
                                <Input
                                    type="text"
                                    name="sgst_tax_rate"
                                    id="mobile"
                                    onChange={this.handleChange}
                                    required
                                    
                                />
                               
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="mobile">IGST Tax Rate</Label>
                                <Input
                                    type="text"
                                    name="igst_tax_rate"
                                    id="mobile"
                                    value = {this.state.sgst_tax_rate + this.state.cgst_tax_rate}
                                    disabled
                                    // onChange={this.handleChange}
                                    required
                                    
                                />
                               
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="mobile">Tax Basis</Label>
                                <Input
                                    type="text"
                                    name="tax_basis"
                                    id="mobile"
                                    value="Percentage"
                                    disabled
                                    onChange={this.handleChange}
                                    
                                />
                               
                            </FormGroup>
                        </Col>
                    </Row>
                   {/* <button onClick={this.createGroup} id="createUserBtn" style={{ backgroundColor: '#FBBB00', borderColor: '#FBBB00', color: 'black', paddingTop: 14, paddingBottom: 14, paddingLeft: 24, paddingRight: 24, marginTop: 10 }} type="button" color="primary">{this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}Save</button>*/}
                     
                </Form>
                </div>
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                    padding: '15px 0',
                    textAlign: 'center',

                }}>
                    <div style={{  margin: '0 auto', marginLeft: '15%' }}>
                        <button 
                            onClick={this.toggleBack} 
                            style={{
                                backgroundColor: 'white',
                                border: '2px solid #FBBB00',
                                color: 'black',
                                padding: '7px 35px',
                                fontSize: '16px',
                                marginRight: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                        <button 
                            onClick={this.createGroup}
                            id="createUserBtn" 
                            style={{
                                backgroundColor: '#FBBB00',
                                border: 'none',
                                color: 'black',
                                padding: '7px 38px',
                                fontSize: '16px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                        {this.state.loading && (
                        <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        )}
                            Save
                        </button>
                    </div>
                </div>


               {/* <div style={{
                       
                        bottom: 0,
                        left: 0,
                        width: '92%',
                        backgroundColor: 'white',
                        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                        padding: '15px 0',
                        textAlign: 'center'
                    }}>
                        <button 
                            onClick={this.toggleBack} 
                            style={{
                                backgroundColor: 'white',
                                border: '2px solid #FBBB00',
                                color: 'black',
                                padding: '12px 24px',
                                fontSize: '16px',
                                marginRight: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                        <button 
                            onClick={this.createItem} 
                            id="createUserBtn" 
                            style={{
                                backgroundColor: '#FBBB00',
                                border: 'none',
                                color: 'black',
                                padding: '12px 24px',
                                fontSize: '16px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Save
                        </button>
                    </div>*/}

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h3>{this.state.success_message} </h3>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleBack}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
              </Modal>

              <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                <div className="modal__header">
                  <button
                    className="lnr lnr-cross modal__close-btn"
                    type="button"
                    style={{ right: 15 }}
                    onClick={this.Failedtoggle}
                  />
                </div>
                <div
                  className="modal__body"
                  style={{ paddingTop: 55, paddingBottom: 20 }}
                >
                  <span
                    className="lnr lnr-cross-circle modal__title-icon"
                    style={{ color: "red" }}
                  />
                  <h4>{this.state.failed_message} </h4>
                   <h5>Below are the errors. Please resolve and then create:</h5>
                    <ul style={{ marginTop: '10px', paddingLeft: '20px', color: 'red', marginLeft: 12 }}>
                      {this.state.failed_errors.map(([field, messages], index) => (
                        <li style={{textAlign: 'left'}} key={index}>
                          <span> <strong>{field}:</strong></span><span> {Array.isArray(messages) ? messages.join(', ') : messages}</span>
                        </li>
                      ))}
                    </ul>
                </div>
                <ButtonToolbar className="modal__footer">
                  <Button
                    style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                    className="modal_ok"
                    onClick={this.Failedtoggle}
                  >
                    Ok
                  </Button>
                </ButtonToolbar>
              </Modal>

       
            </div>


        );
    }
}

export default HorizontalForm;
